<template>
  <div class="controller-news">
    <a-form-model :model="form" :rules="rules" ref="form">
      <a-row :gutter="20" class="mb-30">
        <a-col span="16">
          <h4>Thêm mới bài viết</h4>
        </a-col>
        <a-col :offset="16">
          <a-button type="primary" block @click="handleSubmit">Lưu bài viết</a-button>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="16">
          <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
            <a-form-model-item class="mb-5" label="Tiêu đề" :colon="false" prop="title">
              <a-input v-model="form.title" placeholder="Tên" />
            </a-form-model-item>
            <a-form-model-item class="mb-5" label="Mô tả" :colon="false" prop="description">
              <a-textarea :rows="5" v-model="form.description" placeholder="Mô tả" />
            </a-form-model-item>
            <a-form-model-item class="mb-5" label="Nội dung" prop="content">
              <div class="editor">
                <ckeditor :editor="editor" v-model="form.content" :height="500" :config="editorConfig"></ckeditor>
              </div>
            </a-form-model-item>
          </a-card>
        </a-col>
        <a-col span="8">
          <a-card title="Hiển thị" size="small" class="mb-20">
            <a-form-model-item slot="extra" :colon="false" class="mb-0">
              <a-switch default-checked v-model="form.status" />
            </a-form-model-item>
          </a-card>
          <a-card title="Bài viết nổi bật" size="small" class="mb-20">
            <a-form-model-item slot="extra" :colon="false" class="mb-0">
              <a-switch default-checked v-model="form.hot_news" />
            </a-form-model-item>
          </a-card>
          <a-card title="Danh mục" size="small" class="mb-20">
            <a-form-model-item class="mb-5" :colon="false" prop="category_id">
              <a-select v-model="form.category_id" class="w-full" placeholder="Chọn danh mục" show-search>
                <a-select-option v-for="item in listCategory" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-card>
          <a-card title="Danh mục Product/Service" size="small" class="mb-20">
            <a-form-model-item  label="Loại" class="mb-5" :colon="false" prop="type">
              <a-select v-model="form.type" class="w-full" placeholder="Chọn loại" show-search @change="changeTypeService">
                <a-select-option v-for="item in categoryServiceTypes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              class="mb-5"
              label="Service/Product"
              prop="object_id"
            >
              <a-select
                v-model="form.object_id"
                class="w-full"
                placeholder="Chọn"
                show-search
                allowClear
                option-filter-prop="children"
              >
                <a-select-option
                  v-for="item in seriveOptions"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-card>

          <a-card title="Ngày xuất bản" size="small" class="mb-20">
            <a-form-model-item class="mb-5" :colon="false" prop="publish_at">
              <a-date-picker v-model="form.publish_at" class="w-full" placeholder="Ngày xuất bản" />
            </a-form-model-item>
          </a-card>
          <a-card title="Hỉnh ảnh" size="small" class="mb-20">
            <a-form-model-item class="mb-5" :colon="false">
              <input type="file" accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
                @change="onAvatarChange" />
            </a-form-model-item>
            <img v-show="avatarUrl" id="preview-avatar" :src="avatarUrl" class="preview-avatar" />
          </a-card>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { fetchAllCategory } from "@/services/landing-page/news/category";
import { createArticle, updateArticle, fetchById } from "@/services/landing-page/news/article"
import { fetchService } from '@/services/landing-page/home/service'
import { fetchProductService } from '@/services/landing-page/home/product-service-trying'
import TinymceEditor from "@tinymce/tinymce-vue";
import dayjs from 'dayjs';
import { UploadAdapter } from '@/services/landing-page/uploadAdapter'

function CustomUploadAdapterPlugin( editor ) {
    editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
        return new UploadAdapter( loader );
    };
}

export default {
  name: "ControllerNews",
  components: {
    TinymceEditor
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        height: 500,
         extraPlugins: [ CustomUploadAdapterPlugin ],
      },
      callingAPI: false,

      form: {
        title: "",
        description: "",
        content: "",
        status: false,
        hot_news: false,
        category_id: "",
        author: "",
        publish_at: "",
        thumbnail: null,
        type: null,
        object_id: null,
      },
      rules: {
        title: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"]
          }
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"]
          }
        ],
        category_id: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"]
          }
        ],
        publish_at: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"]
          }
        ]
      },

      listCategory: [],

      avatarUrl: "",
      categoryServiceTypes: [
         {
          id: 1,
          name: 'Product',
        },
        {
          id: 2,
          name: 'Service',
        }
      ],
      seriveOptions: [],
    };
  },
  async beforeMount() {
    this.loadCategory();
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    async loadCategory() {
      try {
        const response = await fetchAllCategory();
        this.listCategory = response.data
      } catch (error) { }
    },

    async loadData() {
      const response = await fetchById(this.$route.params.id)
      const resource = {
        ...response.data,
        status: response.data.status === 1,
        hot_news: response.data.hot_news === 1
      }
      for (var key in this.form) {
        if (response.data.hasOwnProperty(key)) {
          this.form[key] = resource[key]
          if ((this.form[key] === null || this.form[key] ===undefined) && key==='content') {
            this.form[key] = ''
          }
        }
      }
      this.form.type && await this.getServiceOptions()
      this.avatarUrl = `${process.env.VUE_APP_LANDING_PAGE_BACKEND_URL}/${resource.thumbnail}`;
      try {
      } catch (error) { }
    },

    async getServiceOptions() {
      try {
        const response = this.form.type === 1 ? await fetchProductService() : await fetchService()
        console.log(response)
        this.seriveOptions = response?.data?.filter(item => item.type !== 1 && item.high_light !== 1).map(item => ({ id: item.id, name: item.name || item.title })) || [];
      } catch (error) {
      }
    },

    async changeTypeService() {
      this.form.object_id = null
      this.seriveOptions = []
      await this.getServiceOptions()
    },

    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.form.thumbnail = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },

    handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.callingAPI = true;
            const formData = new FormData()
            formData.append("title", this.form.title)
            formData.append("description", this.form.description)
            formData.append("content", this.form.content || '')
            formData.append("status", this.form.status ? 1 : 2)
            formData.append("hot_news", this.form.hot_news ? 1 : 2)
            formData.append("category_id", this.form.category_id)
            if (this.form.type && this.form.object_id) {
              formData.append("type", this.form.type)
              formData.append("object_id", this.form.object_id)
            }
            formData.append("publish_at", dayjs(this.form.publish_at).format('DD/MM/YYYY'))
            if (this.form.thumbnail) {
              formData.append("thumbnail", this.form.thumbnail)
            }
            if (this.$route.params.id) {
              formData.append("_method", "PUT");
            }
            const response = this.$route.params.id ? await updateArticle(this.$route.params.id, formData) : await createArticle(formData)
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật thành công."
                : "Thêm mới thành công.";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
              this.$router.push({path: "/news/article"})
            } else {
              this.$notification.error({
                message: "Thất bại",
                description: response.errors[0],
              });
            }
          } catch (error) {
            this.callingAPI = false;
            let message = this.$route.params.id
              ? "Cập nhật thất bại"
              : "Thêm mới thất bại";
            this.$notification.error({
              message: "Thất bại",
              description: message
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>
<style lang="scss">
.ck-editor__editable {
  min-height: 500px;
}
</style>
